// removed by extract-text-webpack-plugin
module.exports = {"iconWrapper":"Likes-style__iconWrapper__250bee40","icon":"Likes-style__icon__250bee40","hasUnread":"Likes-style__hasUnread__250bee40"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Likes/Likes-style.scss
// module id = ./src/components/Likes/Likes-style.scss
// module chunks = 4